module.exports = __webpack_public_path__ + "static/hero-img-mobile-2d692ed2c81ba0fddf533db938c393cb.jpg";